import { Button } from "@/shared/components/ui/button";
import { LifeBuoy, MessageCircle } from "lucide-react";
import { useRemoteConfigString } from "@/shared/firebase/remoteConfig";

export default function HelpAndSupport() {
  const customerServiceUrl = useRemoteConfigString("customer_service");

  const handleContactSupport = () => {
    const targetUrl =
      customerServiceUrl ?? "https://bizbot360.com/ad-leads/nommia_inquiry";

    window.open(targetUrl, "_blank", "noopener");
  };

  return (
    <section className="flex w-full flex-col gap-6">
      <div className="flex items-center gap-2">
        <LifeBuoy className="size-5 text-primary" />
        <h2 className="text-xl font-semibold">Help &amp; Support</h2>
      </div>

      <p className="text-muted-foreground max-w-2xl text-sm">
        We’re here to assist you! Tap the button below to reach our support
        team. You’ll be redirected to WhatsApp to start the conversation.
      </p>

      <div className="flex items-center gap-3">
        <Button
          variant="primary"
          className="h-10 px-4"
          onClick={handleContactSupport}>
          <span className="inline-flex size-5 items-center justify-center rounded-full bg-green-500">
            <MessageCircle className="size-3 text-white" />
          </span>
          Contact Support
        </Button>
      </div>

      {/* Popular section hidden for now */}
    </section>
  );
}
